import { render, staticRenderFns } from "./InformacoesHistorico.vue?vue&type=template&id=626fdbb3"
import script from "./InformacoesHistorico.vue?vue&type=script&lang=js"
export * from "./InformacoesHistorico.vue?vue&type=script&lang=js"
import style0 from "./InformacoesHistorico.vue?vue&type=style&index=0&id=626fdbb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports